import { createKeychainService } from './service'
export default createKeychainService('auth.token')
